export interface IWACallData {
  id: string; // The WhatsApp call ID (e.g., "wacid.ABGGFjFVU2AfAgo6V-Hc5eCgK5Gh")
  to: string; // The WhatsApp user's phone number (callee)
  from: string; // The business phone number placing the call (caller)
  event: "connect" | "terminate";
  timestamp: string | number; // UNIX timestamp
  direction?: "BUSINESS_INITIATED" | "USER_INITIATED";
  status?: ("Failed" | "Completed")[];
  start_time?: string | number; // Call start UNIX timestamp (only present when call was picked up)
  end_time?: string | number; // Call end UNIX timestamp (only present when call was picked up)
  duration?: number; // Call duration in seconds (only present when call was picked up)
  biz_opaque_callback_data?: string; // Arbitrary string for tracking purposes
  session?: {
    sdp_type: "offer" | "answer";
    sdp: string; // RFC 8866 SDP
  };
  connection?: {
    webrtc: {
      sdp: string; // RFC 8866 SDP
    };
  };
}
export interface iWACallLog {
  id?: string;
  organizationId: string;
  connectionId: string;
  conversationId: string;
  contactId: string;
  ringAgents?: string[];
  callId: string;
  callStatus:
    | "OUTGOING_INIT"
    | "OUTGOING_INIT_SUCCESS"
    | "RINGING"
    | "INCOMING"
    | "IN_PROGRESS"
    | "REJECTED"
    | "COMPLETED";

  // Call Data
  callData?: IWACallData;

  // MetaData
  startedAt: number;
  startedSource: "USER" | "CUSTOMER";
  startedBy: string; // userID or customerId
  /** Who accepted the call (picked up): agent USER vs end CUSTOMER */
  answeredSource?: "USER" | "CUSTOMER";
  answeredAt?: number;
  /** userId when agent answered, or contactId when customer answered (webhook may omit agent id) */
  answeredBy?: string;
  endedAt?: number;
  endedBy?: "USER" | "CUSTOMER";
  endedByUserId?: string;
  duration?: number;
  notes?: string;
  callRecording?: {
    callId: string;
    userId: string;
    startTime: number;
    endTime: number;
    durationMs: number;
    fileSize: number;
    mimeType: string;
    recordingUrl: string;
  };
}

/** User-facing status for lists/UI; differs from raw `callStatus` for COMPLETED calls. */
export function getWACallLogDisplayStatus(log: iWACallLog): string {
  if (log.callStatus === "COMPLETED") {
    const wasAnswered = log.answeredAt != null && log.answeredSource != null;
    if (wasAnswered) {
      return "Completed";
    }
    if (log.startedSource === "CUSTOMER") {
      return "Missed";
    }
    return "Not answered";
  }

  switch (log.callStatus) {
    case "OUTGOING_INIT":
    case "OUTGOING_INIT_SUCCESS":
      return "Outgoing";
    case "RINGING":
      return "Ringing";
    case "INCOMING":
      return "Incoming";
    case "IN_PROGRESS":
      return "In progress";
    case "REJECTED":
      return "Rejected";
    default:
      return log.callStatus;
  }
}
